var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"func-51"}},[_c('funcionalidade-header',{attrs:{"titulo":_vm.tituloNavegacao,"voltar":!_vm.isWidget}}),_c('div',{staticClass:"main"},[_c('SolicitacaoListagem',{attrs:{"funcionalidade":_vm.funcionalidade,"rota-detalhe":_vm.rotaDetalhe,"rota-historico":_vm.rotaHistorico,"rota-novo":_vm.rotaNovo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }